import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow */
import { createAction } from '../../interfaces';
import subscriptionService from '../../services/subscription';
import * as definitions from '../../definitions';
import { redirectActionCreators as redirectActions } from './redirect';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var subscriptionActionCreators = {
  getUserSubscriptionsRequest: function getUserSubscriptionsRequest() {
    return createAction(definitions.GET_SUBSCRIPTIONS_REQUEST);
  },
  getUserSubscriptionsSuccess: function getUserSubscriptionsSuccess(subscriptions) {
    return createAction(definitions.GET_SUBSCRIPTIONS_SUCCESS, subscriptions);
  },
  getUserSubscriptionsFail: function getUserSubscriptionsFail(error) {
    return createAction(definitions.GET_SUBSCRIPTIONS_FAIL, error);
  },
  subscribeToPlanRequest: function subscribeToPlanRequest() {
    return createAction(definitions.SUBSCRIBE_TO_PLAN_REQUEST);
  },
  subscribeToPlanSuccess: function subscribeToPlanSuccess(subscription) {
    return createAction(definitions.SUBSCRIBE_TO_PLAN_SUCCESS, subscription);
  },
  subscribeToPlanFail: function subscribeToPlanFail(error) {
    return createAction(definitions.SUBSCRIBE_TO_PLAN_FAIL, error);
  },
  getSubscriptionRequest: function getSubscriptionRequest() {
    return createAction(definitions.GET_SUBSCRIPTION_REQUEST);
  },
  getSubscriptionSuccess: function getSubscriptionSuccess(subscription) {
    return createAction(definitions.GET_SUBSCRIPTION_SUCCESS, subscription);
  },
  getSubscriptionFail: function getSubscriptionFail(error) {
    return createAction(definitions.GET_SUBSCRIPTION_FAIL, error);
  },
  updateSubscriptionRequest: function updateSubscriptionRequest() {
    return createAction(definitions.UPDATE_SUBSCRIPTION_REQUEST);
  },
  updateSubscriptionSuccess: function updateSubscriptionSuccess(subscription) {
    return createAction(definitions.UPDATE_SUBSCRIPTION_SUCCESS, subscription);
  },
  updateSubscriptionFail: function updateSubscriptionFail(error) {
    return createAction(definitions.UPDATE_SUBSCRIPTION_FAIL, error);
  },
  cancelSubscriptionRequest: function cancelSubscriptionRequest() {
    return createAction(definitions.CANCEL_SUBSCRIPTION_REQUEST);
  },
  cancelSubscriptionSuccess: function cancelSubscriptionSuccess(subscription) {
    return createAction(definitions.CANCEL_SUBSCRIPTION_SUCCESS, subscription);
  },
  cancelSubscriptionFail: function cancelSubscriptionFail(error) {
    return createAction(definitions.CANCEL_SUBSCRIPTION_FAIL, error);
  },
  getSubscriptionPlanRequest: function getSubscriptionPlanRequest() {
    return createAction(definitions.GET_SUBSCRIPTION_PLAN_REQUEST);
  },
  getSubscriptionPlanSuccess: function getSubscriptionPlanSuccess(plan) {
    return createAction(definitions.GET_SUBSCRIPTION_PLAN_SUCCESS, plan);
  },
  getSubscriptionPlanFail: function getSubscriptionPlanFail(error) {
    return createAction(definitions.GET_SUBSCRIPTION_PLAN_FAIL, error);
  },
  clearSubscriptionErrors: function clearSubscriptionErrors() {
    return createAction(definitions.CLEAR_SUBSCRIPTION_ERRORS);
  },
  clearSubscriptionInfo: function clearSubscriptionInfo() {
    return createAction(definitions.CLEAR_SUBSCRIPTION_INFO);
  }
};
export var getUserSubscriptions = function getUserSubscriptions(userId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var getUserSubscriptionsRequest, getUserSubscriptionsSuccess, getUserSubscriptionsFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getUserSubscriptionsRequest = subscriptionActionCreators.getUserSubscriptionsRequest, getUserSubscriptionsSuccess = subscriptionActionCreators.getUserSubscriptionsSuccess, getUserSubscriptionsFail = subscriptionActionCreators.getUserSubscriptionsFail;
              dispatch(getUserSubscriptionsRequest());
              return _context.abrupt("return", subscriptionService.getUserSubscriptions(userId).then(function (subscriptions) {
                dispatch(getUserSubscriptionsSuccess(subscriptions));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getUserSubscriptionsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var createSubscription = function createSubscription(payload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var planId, orderId, receiveEmails, options, successNotificationText, subscribeToPlanRequest, subscribeToPlanSuccess, subscribeToPlanFail, getRedirectPath;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              planId = payload.planId, orderId = payload.orderId, receiveEmails = payload.receiveEmails, options = payload.options, successNotificationText = payload.successNotificationText;
              subscribeToPlanRequest = subscriptionActionCreators.subscribeToPlanRequest, subscribeToPlanSuccess = subscriptionActionCreators.subscribeToPlanSuccess, subscribeToPlanFail = subscriptionActionCreators.subscribeToPlanFail;
              dispatch(subscribeToPlanRequest());

              getRedirectPath = function getRedirectPath(subscription) {
                return (options === null || options === void 0 ? void 0 : options.redirectTo) || "/subscriptions/".concat(subscription.id);
              };

              return _context2.abrupt("return", subscriptionService.createSubscription(planId, orderId, receiveEmails).then(function (subscription) {
                dispatch(subscribeToPlanSuccess(_objectSpread(_objectSpread({}, subscription), {}, {
                  successNotificationText: successNotificationText
                })));

                if (options !== null && options !== void 0 && options.shouldRedirect) {
                  dispatch(redirectActions.redirectTo(getRedirectPath(subscription)));
                }

                return subscription;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(subscribeToPlanFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getSubscriptionById = function getSubscriptionById(subscriptionId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var getSubscriptionRequest, getSubscriptionSuccess, getSubscriptionFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getSubscriptionRequest = subscriptionActionCreators.getSubscriptionRequest, getSubscriptionSuccess = subscriptionActionCreators.getSubscriptionSuccess, getSubscriptionFail = subscriptionActionCreators.getSubscriptionFail;
              dispatch(getSubscriptionRequest());
              return _context3.abrupt("return", subscriptionService.getSubscriptionById(subscriptionId).then(function (subscription) {
                dispatch(getSubscriptionSuccess(subscription));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getSubscriptionFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var updateSubscription = function updateSubscription(payload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var updateSubscriptionRequest, updateSubscriptionSuccess, updateSubscriptionFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              updateSubscriptionRequest = subscriptionActionCreators.updateSubscriptionRequest, updateSubscriptionSuccess = subscriptionActionCreators.updateSubscriptionSuccess, updateSubscriptionFail = subscriptionActionCreators.updateSubscriptionFail;
              dispatch(updateSubscriptionRequest());
              return _context4.abrupt("return", subscriptionService.updateSubscription(payload).then(function (subscription) {
                dispatch(updateSubscriptionSuccess(subscription));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateSubscriptionFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var cancelSubscription = function cancelSubscription(subscriptionId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var cancelSubscriptionRequest, cancelSubscriptionSuccess, cancelSubscriptionFail;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              cancelSubscriptionRequest = subscriptionActionCreators.cancelSubscriptionRequest, cancelSubscriptionSuccess = subscriptionActionCreators.cancelSubscriptionSuccess, cancelSubscriptionFail = subscriptionActionCreators.cancelSubscriptionFail;
              dispatch(cancelSubscriptionRequest());
              return _context5.abrupt("return", subscriptionService.cancelSubscription(subscriptionId).then(function (subscription) {
                dispatch(cancelSubscriptionSuccess(subscription));
                return subscription;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(cancelSubscriptionFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var getSubscriptionPlanById = function getSubscriptionPlanById(planId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var getSubscriptionPlanRequest, getSubscriptionPlanSuccess, getSubscriptionPlanFail;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              getSubscriptionPlanRequest = subscriptionActionCreators.getSubscriptionPlanRequest, getSubscriptionPlanSuccess = subscriptionActionCreators.getSubscriptionPlanSuccess, getSubscriptionPlanFail = subscriptionActionCreators.getSubscriptionPlanFail;
              dispatch(getSubscriptionPlanRequest());
              return _context6.abrupt("return", subscriptionService.getSubscriptionPlanById(planId).then(function (plan) {
                dispatch(getSubscriptionPlanSuccess(plan));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getSubscriptionPlanFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var clearSubscriptionErrors = function clearSubscriptionErrors() {
  return function (dispatch) {
    var clearSubscriptionErrorsAction = subscriptionActionCreators.clearSubscriptionErrors;
    dispatch(clearSubscriptionErrorsAction());
  };
};
export var clearSubscriptionInfo = function clearSubscriptionInfo() {
  return function (dispatch) {
    var clearSubscriptionInfoAction = subscriptionActionCreators.clearSubscriptionInfo;
    dispatch(clearSubscriptionInfoAction());
  };
};